    <!-- Header -->
    <div class="flex flex-col -m-6">
        <div class="flex flex-0 sticky -top-6 z-50 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
            <div class="text-lg font-medium">Información</div>
            <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
                <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x'"></mat-icon>
            </button>
        </div>
        <p class="p-8">{{ data.clipboardItem.data }}</p>
    </div>
    